import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-custom-link',
  templateUrl: './custom-link.component.html',
  styleUrls: ['./custom-link.component.scss']
})
export class CustomLinkComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
